const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(function () {
  function updateWcpaPrices() {
    document.querySelectorAll('.wcpa_option_price').forEach(function (el) {
      var text = (el.textContent || '')
        .replace(/\u00A0/g, ' ')
        .replace(/\s+/g, '')
        .trim();

      if (text.length > 0) {
        el.classList.add('wcpa-has-price');
      } else {
        el.classList.remove('wcpa-has-price');
      }
    });
  }

  updateWcpaPrices();

  document.addEventListener('DOMContentLoaded', updateWcpaPrices);
  window.addEventListener('load', updateWcpaPrices);

  new MutationObserver(updateWcpaPrices).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();


document.addEventListener('DOMContentLoaded', function () {
  function forceUppercase(field) {
    if (!field || typeof field.value !== 'string') return;

    const start = field.selectionStart;
    const end = field.selectionEnd;

    field.value = field.value.toUpperCase();

    if (document.activeElement === field && typeof field.setSelectionRange === 'function') {
      field.setSelectionRange(start, end);
    }
  }

  document.addEventListener('input', function (event) {
    const field = event.target;

    if (
      field.matches &&
      (
        field.matches('input.wcpa_field[type="text"]') ||
        field.matches('textarea.wcpa_field')
      )
    ) {
      forceUppercase(field);
    }
  });

  document.addEventListener('change', function (event) {
    const field = event.target;

    if (
      field.matches &&
      (
        field.matches('input.wcpa_field[type="text"]') ||
        field.matches('textarea.wcpa_field')
      )
    ) {
      forceUppercase(field);
    }
  });

  document.addEventListener('paste', function (event) {
    const field = event.target;

    if (
      field.matches &&
      (
        field.matches('input.wcpa_field[type="text"]') ||
        field.matches('textarea.wcpa_field')
      )
    ) {
      setTimeout(function () {
        forceUppercase(field);
      }, 0);
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form || !form.querySelectorAll) return;

    form.querySelectorAll('input.wcpa_field[type="text"], textarea.wcpa_field').forEach(function (field) {
      forceUppercase(field);
    });
  }, true);
});